/**
 * Belgeleri filtreleme işlemini oluşturur
 * 
 * @param {Object} state - Uygulama state
 * @param {Object} filterMethods - Filtreleme metodları
 * @param {Function} sortDocuments - Sıralama fonksiyonu
 * @returns {Function} - Belgeleri filtreleme fonksiyonu
 */
export const createFilterDocumentsMethod = (state, filterMethods, sortDocuments) => {
  const {
    allDocuments,
    documents,
    filters,
    searchQuery,
    pagination,
  } = state;

  /**
   * Sayfalamayı sıfırla
   */
  const resetPagination = () => {
    pagination.currentPage = 1;
  };

  /**
   * Frontend'de belgeleri filtrele ve sırala
   */
  return () => {
    if (allDocuments.value.length === 0) {
      documents.value = [];
      return;
    }

    // Başlangıçta tüm belgeleri göster
    let result = [...allDocuments.value];

    // Dosya türü filtreleme
    if (filters.fileType) {
      result = filterMethods.filterByFileType(result, filters.fileType);
    }

    // Kategori filtreleme
    if (filters.categoryIds && filters.categoryIds.length > 0) {
      result = filterMethods.filterByCategory(result, filters.categoryIds);
    }

    // Tarih filtreleme
    if (filters.dateFilter) {
      result = filterMethods.filterByDate(result, filters.dateFilter);
    }

    // Arama terimine göre filtreleme
    if (searchQuery.value) {
      result = filterMethods.filterBySearchQuery(result, searchQuery.value);
    }

    // Sıralama uygula
    result = sortDocuments(result);

    // Filtrelenmiş belgeleri güncelle
    documents.value = result;

    // Sayfalamayı sıfırla
    resetPagination();
  };
};